<header class="flex shrink-0 justify-between items-center gap-2 border-b-[1px] border-primary-100 bg-basic-100 py-3 px-4">
  <l-text t="h3" tone="default" flow="inline-block" class="text-nowrap">Meu Perfil</l-text>
  <button lButton bContent="icon" [bSize]="'small'" type="button" (click)="close()" aria-label="Fechar">
    <l-icon class="text-base text-inherit" icon="close" aria-hidden="true" />
  </button>
</header>

<main class="form-content-enter flex min-h-0 flex-1 flex-col overflow-y-auto px-5 py-5" [formGroup]="form">

  <div class="mb-6 flex items-center gap-4">
    <div class="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-primary-500">
      <l-text t="h2" tone="default" strong="bold" class="select-none text-basic-100">{{ avatarInitial() }}</l-text>
    </div>
    <div class="min-w-0">
      <l-text t="body1" tone="default" strong="semibold" flow="block" class="truncate">{{ me()?.name || '—' }}</l-text>
      <l-text t="body2" tone="muted" flow="block" class="truncate">{{ me()?.email || '—' }}</l-text>
    </div>
  </div>

  <div class="grid w-full grid-cols-12 gap-x-4 gap-y-5">

    <div class="form-field-stack col-span-12">
      <l-input-label for="profile-name" [bSize]="ButtonSizeEnum.LARGE">Nome</l-input-label>
      <input
        id="profile-name"
        type="text"
        maxlength="150"
        [bSize]="ButtonSizeEnum.LARGE"
        [class.!border-danger-500]="validation().name.invalid && validation().name.dirty"
        formControlName="name"
        lInput
        autocomplete="name"
      />
      @for (error of validation().name.errors; track error) {
        <l-small-error>{{ error }}</l-small-error>
      }
    </div>

    <div class="form-field-stack col-span-12">
      <l-input-label for="profile-email" [bSize]="ButtonSizeEnum.LARGE">E-mail</l-input-label>
      <input
        id="profile-email"
        type="email"
        maxlength="255"
        [bSize]="ButtonSizeEnum.LARGE"
        [class.!border-danger-500]="validation().email.invalid && validation().email.dirty"
        formControlName="email"
        lInput
        autocomplete="email"
      />
      @for (error of validation().email.errors; track error) {
        <l-small-error>{{ error }}</l-small-error>
      }
    </div>

    <div class="col-span-12 flex items-center gap-3 pt-1">
      <div class="h-px flex-1 bg-primary-100"></div>
      <button
        lButton
        [bType]="'basic'"
        outline
        [bSize]="'small'"
        type="button"
        (click)="togglePasswordSection()"
      >
        <l-icon
          class="mr-1 text-sm text-inherit"
          [icon]="showPasswordSection() ? 'lock_open' : 'lock'"
          aria-hidden="true"
        />
        {{ showPasswordSection() ? 'Cancelar' : 'Alterar senha' }}
      </button>
      <div class="h-px flex-1 bg-primary-100"></div>
    </div>

    @if (showPasswordSection()) {

      <div class="form-field-stack col-span-12">
        <l-input-label for="current-password" [bSize]="ButtonSizeEnum.LARGE">Senha atual</l-input-label>
        <input
          id="current-password"
          type="password"
          maxlength="55"
          [bSize]="ButtonSizeEnum.LARGE"
          [class.!border-danger-500]="validation().currentPassword.invalid && validation().currentPassword.dirty"
          formControlName="currentPassword"
          lInput
          autocomplete="current-password"
        />
        @for (error of validation().currentPassword.errors; track error) {
          <l-small-error>{{ error }}</l-small-error>
        }
      </div>

      <div class="form-field-stack col-span-12 sm:col-span-6">
        <l-input-label for="new-password" [bSize]="ButtonSizeEnum.LARGE">Nova senha</l-input-label>
        <input
          id="new-password"
          type="password"
          maxlength="55"
          [bSize]="ButtonSizeEnum.LARGE"
          [class.!border-danger-500]="validation().newPassword.invalid && validation().newPassword.dirty"
          formControlName="newPassword"
          lInput
          autocomplete="new-password"
        />
        @for (error of validation().newPassword.errors; track error) {
          <l-small-error>{{ error }}</l-small-error>
        }
      </div>

      <div class="form-field-stack col-span-12 sm:col-span-6">
        <l-input-label for="confirm-password" [bSize]="ButtonSizeEnum.LARGE">Confirmar nova senha</l-input-label>
        <input
          id="confirm-password"
          type="password"
          maxlength="55"
          [bSize]="ButtonSizeEnum.LARGE"
          [class.!border-danger-500]="validation().confirmPassword.invalid && validation().confirmPassword.dirty"
          formControlName="confirmPassword"
          lInput
          autocomplete="new-password"
        />
        @for (error of validation().confirmPassword.errors; track error) {
          <l-small-error>{{ error }}</l-small-error>
        }
        @if (form.errors?.['passwordsMismatch'] && form.get('confirmPassword')?.dirty) {
          <l-small-error>As senhas não coincidem</l-small-error>
        }
      </div>

    }

  </div>
</main>

<footer class="flex shrink-0 justify-end gap-2 border-t-[1px] border-primary-100 bg-basic-100 px-4 py-3">
  <button
    lButton
    [bType]="'basic'"
    outline
    type="button"
    (click)="close()"
    [lDisabled]="isSaving()"
  >
    Cancelar
  </button>

  <button
    lButton
    [bType]="'primary'"
    type="button"
    class="relative"
    (click)="submit()"
    [lDisabled]="!canSubmit()"
    [class.text-transparent]="isSaving()"
    [attr.aria-busy]="isSaving()"
  >
    @if (isSaving()) {
      <div class="absolute flex items-center justify-center" aria-hidden="true">
        <l-icon class="animate-spin text-xl text-basic-100" icon="progress_activity" />
      </div>
    }
    Salvar
  </button>
</footer>
